export default class TransactionResponse {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.transactionId = jsonResponse["transaction-id"];
            this.fee = jsonResponse["fees"];
            this.vat = jsonResponse["vat"];
            this.total = jsonResponse["total"];
            this.destinationAmount = jsonResponse["destination-amount"];
            this.destinationCurrency = jsonResponse["destination-currency"];
            this.destinationCountry = jsonResponse["destination-country"];
        }
    }
}
